import { useStoreSetting } from '@/app/(store)/s/[domain]/store-context';
import BuyerIcon from '@/components/icons/buyer-icon';
import MapsPinIcon from '@/components/icons/maps-pin-icon';
import OrderIcon from '@/components/icons/order-icon';
import ProfileIcon from '@/components/icons/profile-icon';
import ButtonLogout from '@/components/sections/customer/store/button-logout';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { StarIcon } from 'lucide-react';
import { useRouter } from 'next/navigation';

export function UserNav() {
  const router = useRouter();
  const { storeSetting } = useStoreSetting();
  const isReviewActive = storeSetting?.product_settings?.review_product;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant='ghost'
          size='icon'
          className='inline-flex items-center hover:cursor-pointer'
        >
          <BuyerIcon className='h-7 w-7' data-test='buyer-icon' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='z-[105] w-56 p-2' align='end' forceMount>
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => router.push('/account')} data-testid='profile-icon'>
            <ProfileIcon className='mr-2 h-6 w-6' /> My Profile
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => router.push('/account/order')} data-testid='order-icon'>
            <OrderIcon className='mr-2 h-6 w-6' /> My Orders
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => router.push('/account/address')}
            data-testid='address-icon'
          >
            <MapsPinIcon className='mr-2 h-6 w-6' /> My Address
          </DropdownMenuItem>
        </DropdownMenuGroup>
        {isReviewActive && (
          <DropdownMenuItem
            onClick={() => router.push('/account/reviews?tab=unreviewed')}
            data-testid='review-icon'
          >
            <StarIcon className='mr-2 h-4 w-4' /> My Reviews
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <ButtonLogout />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
